import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "documents",
    name: "documents",
    component: () => import("./pages/DocumentsPage.vue"),
    meta: {
      requiresAuth: true,
      title: "menu.documents",
    },
  },
];
